export default "__VITE_ASSET__wGsn1i5w__"